import React, { useEffect } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import services_pic_1 from "../assests/project_image_1.jpg";
import services_pic_2 from "../assests/project_image_3.png";
import NewsletterSection from "./NewsLetter";
import HeroSection from "./HeroSection";

const BlogPost = ({ image, category, date, title, excerpt, path, aosDelay }) => (
  <Link to={path} className="block w-full">
    <div 
      className="flex flex-col lg:flex-row gap-4 sm:gap-6 p-4 sm:p-6 bg-lightBlue rounded-lg hover:shadow-lg transition-shadow"
      data-aos="fade-up"
      data-aos-delay={aosDelay}
    >
      <div className="w-full lg:w-2/5">
        <img
          src={image}
          alt={title}
          className="w-full h-48 sm:h-56 md:h-64 lg:h-72 object-cover rounded-lg"
        />
      </div>
      <div className="w-full lg:w-3/5 space-y-3 sm:space-y-4">
        {/* <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
          <span className="text-sm text-gray-600">{category}</span>
          <span className="text-sm text-gray-600">{date}</span>
        </div> */}
        <h2 className="font-nova-square text-xl sm:text-2xl font-bold text-gray-800">{title}</h2>
        <p className="text-gray-600 text-base sm:text-lg">{excerpt}</p>
        <button className="text-blue-600 font-medium hover:text-blue-700 flex items-center gap-1 text-base sm:text-lg">
          Read More
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  </Link>
);

function Project() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out'
    });
    window.scrollTo(0, 0);
  }, []);

  const posts = [
    {
      image: services_pic_1,
      category: "Email Hosting",
      date: "20 Aug 2024",
      title: "PROJECT ORiONß",
      excerpt: "Kristellar Aerospace was founded in 2021 with a vision for sustainable human and robotics...",
      path: '/project/project1',
      aosDelay: '0'
    },
    {
      image: services_pic_2,
      category: "Email Hosting",
      date: "20 Aug 2024",
      title: "RiGEL UCAV On SWaP Platform",
      excerpt: "The nation moves into a new era of defence through unparalleled intelligence, surveillance, and reconnaissance...",
      path: '/project/project2',
      aosDelay: '100'
    },
  ];

  return (
    <div className="min-h-screen bg-lightBlue">
      <Header />
      <Navbar />

      {/* Hero Section */}
      {/* <div className="bg-customBlue text-white py-8 sm:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div data-aos="fade-up" className="space-y-3 sm:space-y-4 flex flex-col items-center text-center">
            <h1 className="font-nova-square text-3xl sm:text-4xl font-thin text-black">
              Projects
            </h1>
            <p className="text-black text-sm sm:text-base">
              <Link to={"/"}> Home </Link>{' > '} <Link to={"/project"}>Projects </Link>
            </p>
          </div>
        </div>
      </div> */}
      <HeroSection 
        title="Projects" 
        breadcrumb={
          <>
            <Link to={"/project"}>Projects</Link> 
            {/* <Link to={"/products/products1"}>Mission Control Software for Cubesat</Link> */}
          </>
        } 
      />

      {/* Projects Grid */}
      <div className="max-w-7xl mx-auto p-12 sm:p-6 bg-lightBlue">
        <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-2">
          {posts.map((post, index) => (
            <BlogPost key={index} {...post} />
          ))}
        </div>
      </div>

      <NewsletterSection />
      <Footer />
    </div>
  );
}

export default Project;